var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"callout",class:_vm.type},[_c('div',{staticClass:"icon"},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"spin":_vm.spin}}):_vm._e()],1),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }